import { TransitionDirection, TransitionKind } from "@repo/api/transition";
import {
  getDefaultDurationInFrames,
  getDefaultPreviewClipDurationsInFrames,
  getDefaultTiming,
  ImageTransitionBuilder,
} from "./ImageTransitionBuilder.ts";
import { slide, SlideDirection, SlideProps } from "@remotion/transitions/slide";

const transitionKind = TransitionKind.enum.PUSH;

const remotionDirections: Partial<Record<TransitionDirection, SlideDirection>> =
  {
    FROM_LEFT: "from-left",
    FROM_RIGHT: "from-right",
    FROM_TOP: "from-top",
    FROM_BOTTOM: "from-bottom",
  };

export const ImagePushTransitionBuilder: ImageTransitionBuilder<SlideProps> = {
  formConfig: {
    kind: transitionKind,
    buildDefaultValue: () => ({
      kind: transitionKind,
      speed: "NORMAL",
      direction: "FROM_LEFT",
    }),
    speed: ["SLOW", "NORMAL", "FAST"],
    direction: ["FROM_LEFT", "FROM_RIGHT", "FROM_TOP", "FROM_BOTTOM"],
  },

  transition: {
    getDurationInFrames: getDefaultDurationInFrames,
    buildPresentation: (props) =>
      slide({
        direction: remotionDirections[props.imageTransition.direction!]!,
      }),
    buildTiming: getDefaultTiming,
  },

  getPreviewClipDurationsInFrames: getDefaultPreviewClipDurationsInFrames,
};
